export default __webpack_public_path__ + "static/media/07_DAIF_SUSTAINABILITY_01.e2fb4744.mp4";